export const attachmentListStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		gap: 2,
		flexWrap: 'wrap'
	}
};
